module.exports = __webpack_public_path__ + "ic-question-mark.svg?bf16c3c46c05b83c7c60dc8eef901eca";